import { FormattedMessage } from 'components/Commons/Translation'
import PadlockSvg from 'assets/svg/lock.svg?react'

import { useApplicationOrganizationPicker } from 'context/Organization'

import { Container, Title, Message, Icon, Button } from './styled'

import translations from './translations'

function OrganizationSwitcherCTA() {
  const { setOpenOrganizationPicker } = useApplicationOrganizationPicker()

  function onOpen() {
    setOpenOrganizationPicker(true)
  }

  return (
    <Button onClick={onOpen}>
      <FormattedMessage {...translations.permissionRequiredAction} />
    </Button>
  )
}

function AccessForbidden({
  title = translations.permissionRequiredTitle,
  message = translations.permissionRequiredMessage,
  switchOrganization = false,
}) {
  return (
    <Container>
      <Icon component={PadlockSvg} />
      <Title>
        <FormattedMessage {...title} />
      </Title>
      <Message>
        <FormattedMessage {...message} />
      </Message>
      {switchOrganization && <OrganizationSwitcherCTA />}
    </Container>
  )
}

export default AccessForbidden
